export const SET = 'Set'
export const ADD = 'Add'
export const UPDATE = 'Update'
export const DELETE = 'Delete'
export const SET_CLEAN = 'SetClean'
export const SET_DIRTY = 'SetDirty'
export const USER_AUTHENTICATED = 'UserAuthenticated'
export const MARK_INITIALIZED = 'MarkInitialized'
export const SET_FLOW_SEARCH_TERM = 'SetFlowSearchTerm'
export const SET_FIELD_SEARCH_TERM = 'SetFieldSearchTerm'
export const SET_MAIN_MENU_PINNED = 'SetMainMenuPinned'
export const ALLOW_DEFAULT_PREF_USE = 'AllowDefaultPrefUse'
export const REQUEST_SAVE = 'RequestSave'
export const ADD_TASK = 'AddTask'
export const COMPLETE_TASK = 'CompleteTask'
export const REMOVE_TASK = 'RemoveTask'

export default {
  SET,
  ADD,
  UPDATE,
  DELETE,
  SET_CLEAN,
  SET_DIRTY,
  USER_AUTHENTICATED,
  MARK_INITIALIZED,
  SET_FLOW_SEARCH_TERM,
  SET_FIELD_SEARCH_TERM,
  SET_MAIN_MENU_PINNED,
  ALLOW_DEFAULT_PREF_USE,
  REQUEST_SAVE,
  ADD_TASK,
  COMPLETE_TASK,
  REMOVE_TASK
}
